import config from "shared/config";
import { normalizeApiToIdHash } from "./normalizeApi";

export function extractReferencesFromResponse(apiData, resourceNames) {
  if (!apiData) {
    return {};
  }

  const resultData = {};

  Object.entries(apiData).forEach(([index, resourceResponse]) => {
    // first data is response data, 2nd json-api format
    const resourceData = resourceResponse.data.data;
    const resourceName = resourceNames[index] || "unknownResource";
    if (
      resourceName === "unknownResource" &&
      config.clientEnv === "development"
    ) {
      console.warn(
        "resourceNames must be passed to extractReferencesFromResponse",
      );
    }

    if (Array.isArray(resourceData)) {
      resultData[resourceName] = resourceData.map(record => record.id);
    } else {
      resultData[resourceName] = [resourceData.id];
    }
  });

  return resultData;
}

export function extractContentsFromResponse(apiData, resourceNames) {
  if (!apiData) {
    return {};
  }

  const resultData = {};

  Object.entries(apiData).forEach(([index, resourceResponse]) => {
    const resourceName = resourceNames[index] || "unknownResource";
    if (
      resourceName === "unknownResource" &&
      config.clientEnv === "development"
    ) {
      console.warn(
        "resourceNames must be passed to extractContentsFromResponse",
      );
    }

    resultData[resourceName] = {
      ...normalizeApiToIdHash(resourceResponse.data, resourceName),
    };
  });

  return resultData;
}
